import http from '../common/api';
import {ApiSettings} from "application";

const saveRequest = async (data) => {
  const payload = {
    "id_solicitud": data.requestId,
    "plan": data.planSelected.type,
    "amount": data.planSelected.price,
    'payment_type': data.paymentType,
    'rut_billing': data.billInfo.rut,
    'social_reason': data.billInfo.businessType,
    'economic_activity': data.billInfo.economicActivity,
    'address': data.billInfo.address,
    "preferencia_ppu": data.licenseNumber
  }

  return await http.post(ApiSettings.saveRequest, payload);
}

export default saveRequest;
